(function () {
'use strict';

angular.module('hyresgastApp').filter('hyNextNumber', function() {
  return function(input) {
    return Number(input) + 1;
  };
});

})();